import React, { Component } from "react";
import { connect } from "react-redux";

//import { fetchLatestResources } from "Thunks";
import { resetResources, setCurrentNavPage } from "Actions";
import { APP_ENV } from "Config";

import ArticlesList from "./NewCommunity/ArticlesList";
import TopicsList from "./NewCommunity/TopicsList";
//import WorkflowList from "./NewCommunity/WorkflowList";
import MediasList from "./NewCommunity/MediasList";
import EventsList from "./NewCommunity/EventsList";
import WorkPlace from "./WorkPlace";
import ClientSpace from "./ClientSpace";
import Header from "./NewCommunity/Header";
import SendWidget from "./NewCommunity/SendWidget";
import DrawersList from "./NewCommunity/DrawersList";
import DrawerIframe from "./NewCommunity/DrawerIframe";
import Widget from "./Widget";

import { getUserLayouts } from "Utils";

import drawerStyles from "./NewCommunity/DrawersList/DrawersList.local.scss";

export class Community extends Component {
  constructor(props) {
    super(props);
    this.state = {
      autoFetching: true,
      offset: 0,
      type: "ALL",
      search: null,
      timeout: null
    };
  }

  componentDidMount() {
    this.props.setCurrentNavPage("COMMUNITY_PAGE");
  }

  renderWorkPortal() {
    const { community, loggedAs } = this.props;

    return loggedAs === "CLIENT" ? (
      <ClientSpace community={community} />
    ) : (
      <WorkPlace community={community} />
    );
  }

  renderCommunityPortal() {
    const { community, selectedLayout, user, auth } = this.props;

    let blocs = [];
    let widgets = [];
    let apps = [];
    if (
      community &&
      community.hubPreferences &&
      community.hubPreferences.layout_settings
    ) {
      const { layout_settings } = community.hubPreferences;
      const layouts = getUserLayouts(user, layout_settings, community.id);

      blocs =
        layouts.length > selectedLayout && layouts[selectedLayout].config
          ? layouts[selectedLayout].config.filter(bloc => bloc.enabled === true)
          : [];
      widgets =
        layouts.length > selectedLayout && layouts[selectedLayout].widgets
          ? layouts[selectedLayout].widgets
          : [];
      apps =
        layouts.length > selectedLayout && layouts[selectedLayout].apps
          ? layouts[selectedLayout].apps
          : [];
    }

    return (
      <div id="new-community-page">
        {/* <Header community={community} widgets={widgets} /> */}

        {/* {this.renderBlocs(blocs.filter(bloc => bloc.type !== "OTHER"))} */}

        <div className={drawerStyles.drawers_box}>
          <DrawersList community={community} blocs={blocs} apps={apps} />
          <DrawerIframe />
        </div>

        {(widgets.includes("ARTICLE") || widgets.includes("TAMTAMIT")) && (
          <Widget widgets={widgets} />
        )}

        <div className={drawerStyles.widgets}>
          {widgets.includes("SENDING") && <SendWidget />}
        </div>
      </div>
    );
  }

  renderBlocs(blocs) {
    const { community } = this.props;

    for (let i = 0; i < blocs.length - 1; i++) {
      for (let j = i + 1; j < blocs.length; j++) {
        if (blocs[j].order < blocs[i].order) {
          let help = blocs[i];
          blocs[i] = blocs[j];
          blocs[j] = help;
        }
      }
    }
    if (blocs.length === 0) {
      return null;
    }

    return blocs.map(bloc => {
      switch (bloc.type.toUpperCase()) {
        case "BLOG":
          return (
            <ArticlesList
              community={community}
              order={bloc.order}
              conditions={bloc.conditions}
              disposition={bloc.disposition}
              key={`article-list-${bloc.order}`}
            />
          );
        case "EVENT":
          return (
            <EventsList
              community={community}
              order={bloc.order}
              disposition={bloc.disposition}
              conditions={bloc.conditions}
              key={`article-list-${bloc.order}`}
            />
          );
        case "FORUM":
          return (
            <TopicsList
              community={community}
              order={bloc.order}
              conditions={bloc.conditions}
              key={`topic-list-${bloc.order}`}
            />
          );
        case "MEDIA":
          return (
            <MediasList
              community={community}
              order={bloc.order}
              disposition={bloc.disposition}
              conditions={bloc.conditions}
              key={`media-list-${bloc.order}`}
            />
          );
      }
    });
  }

  render() {
    const { community, currentPortal } = this.props;
    //const { autoFetching, type } = this.state;

    if (!community) {
      return null;
    }

    return this.renderCommunityPortal();
  }
}

// Connected Component
const mapStateToProps = state => ({
  auth: state.auth,
  user: state.auth.user,
  community: state.auth.navCommunity,
  loggedAs: state.auth.loggedAs,
  currentPortal: state.auth.currentPortal,
  selectedLayout: state.auth.selectedLayout
});

const mapDispatchToProps = dispatch => ({
  //fetchLatestResources: options => dispatch(fetchLatestResources(options)),
  setCurrentNavPage: page => dispatch(setCurrentNavPage(page)),
  resetResources: () => dispatch(resetResources())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Community);



// WEBPACK FOOTER //
// ./src/components/Community/Community.js